import React from 'react';
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import LogosBar from './components/LogosBar/LogosBar';
import Services from './components/Services/Services';
import ProductShowcase from './components/ProductShowcase/ProductShowcase';
import TechStack from './components/TechStack/TechStack';
import Stats from './components/Stats/Stats';
import CTA from './components/CTA/CTA';
import Footer from './components/Footer/Footer';
import './styles/variables.css';
import './styles/animations.css';
import './styles/buttons.css';
import './styles/responsive.css';

function App() {
    return (
        <div className="App">
            <Navbar />
            <Hero />
            <LogosBar />
            <Services />
            <ProductShowcase />
            <TechStack />
            <Stats />
            <CTA />
            <Footer />
        </div>
    );
}

export default App;